import React, { FunctionComponent } from 'react';
import { Outlet } from 'react-router-dom';

export const TransactionMonitoring: FunctionComponent = () => {
  return <Outlet />;
};
